module.exports = __webpack_public_path__ + "img/FinTurno-reporte.2bb4e033.png";